import { omitBy, isUndefined } from 'lodash';

export const CHAT_AGENT_ACTION_PROPS = {
    TYPE: 'type',
    DATA: 'data',
    METADATA: 'actionMetadata',
    STATUS: 'status',
    ID: 'actionId',
};

const { TYPE, DATA, METADATA, STATUS, ID } = CHAT_AGENT_ACTION_PROPS;

export const getActionDetails = (action = {}) => ({
    type: action[TYPE],
    data: action[DATA],
    metadata: action[METADATA],
    status: action[STATUS],
    id: action[ID],
});

export const formatAction = ({ data, type, metadata, status, id }) =>
    omitBy(
        {
            [TYPE]: type,
            [DATA]: data,
            [METADATA]: metadata,
            [STATUS]: status,
            [ID]: id,
        },
        isUndefined
    );
